// 
export const FREE_PLAN_KEY = 'BA_FREE_PLAN';
export const BASIC_PLAN_KEY = 'BA_BASIC_PLAN';
export const COMPLETE_PLAN_KEY = 'BA_COMPLETE_PLAN';
export const COMPLETE_PLAN_KEY_US = 'BA_COMPLETE_PLAN_US';
export const PREMIUM_PLAN_KEY = 'BA_PREMIUM_PLAN';
export const PREMIUM_PLAN_KEY_US = 'BA_PREMIUM_PLAN_US';